import './AttachmentsBreadcrumbs.scss';
import { useTranslator } from '@Localization';
import { Breadcrumbs, Link, Typography } from '@mui/joy';
import { ReactElement } from 'react';
import { IAttachmentBreadcrumb } from '../attachments.store';

export interface IAttachmentsBreadcrumbsProps {
  breadcrumbs: IAttachmentBreadcrumb[];
  onFolderSelect: (id: string) => void;
}

export const AttachmentsBreadcrumbs = ({ breadcrumbs, onFolderSelect }: IAttachmentsBreadcrumbsProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <>
      {breadcrumbs && breadcrumbs.length ? (
        <Breadcrumbs
          className='attachments-breadcrumbs'
          size='lg'
          sx={{ padding: 0 }}
        >
          <Link
            color='neutral'
            onClick={(): void => {
              onFolderSelect('');
            }}
            key={'breadcrumb-home'}
          >
            {t('attachments_header')}
          </Link>
          {breadcrumbs.map((breadcrumb, i) =>
            i > breadcrumbs.length - 1 ? (
              <Link
                key={`breadcrumb-${breadcrumb.id}`}
                onClick={(): void => {
                  onFolderSelect(breadcrumb.id);
                }}
              >
                {breadcrumb.name}
              </Link>
            ) : (
              <Typography key={`breadcrumb-${breadcrumb.id}`}>{breadcrumb.name}</Typography>
            )
          )}
        </Breadcrumbs>
      ) : (
        ''
      )}
    </>
  );
};
